export default {
  system: null,
  initialized: false,
  authUser: null,
  errorMessage: null,
  successMessage: null,
  errorCode: null
};
